import { useAppStore } from '@modules/app/store/useAppStore';
import { FloorplanRevision } from '@/modules/localDevHelpers/FloorplanDesign';

import { useFloorplanDesignStore } from '../store/useFloorplanDesignStore';

export const useReadSelectedObstacles = (): FloorplanRevision['design']['obstacles'] => {
  const ids = useAppStore((state) => state.selectedIds);
  return useFloorplanDesignStore().getObstaclesByIds(ids);
};
